import { render, staticRenderFns } from "./vue-xlsx-table.vue?vue&type=template&id=257562e2"
import script from "./vue-xlsx-table.vue?vue&type=script&lang=js"
export * from "./vue-xlsx-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports